<section
  class="flex max-h-full min-h-0 flex-col overflow-hidden rounded-lg border border-surface-switch-200 bg-surface-switch-0"
>
  <header
    class="flex items-center justify-between gap-3 border-b border-surface-switch-200 px-3 py-2"
  >
    <span class="text-sm font-medium text-surface-switch-900">CAD Objects</span>
    <div class="flex shrink-0 gap-1">
      @if (cadFileId !== null) {
        <p-button
          label="CAD"
          icon="pi pi-download"
          severity="secondary"
          [outlined]="true"
          size="small"
          [loading]="downloadingCad()"
          (onClick)="onDownloadCad()"
          aria-label="Download CAD"
        />
      }
      @if (dxfFileUrl) {
        <a
          pButton
          label="DXF"
          icon="pi pi-download"
          severity="secondary"
          [outlined]="true"
          size="small"
          [href]="dxfFileUrl"
          target="_blank"
          rel="noopener"
          aria-label="Download DXF"
        ></a>
      }
    </div>
  </header>

  <div class="min-h-0 overflow-y-auto p-2">
    @for (cadObject of cadObjects; track cadObject.id) {
      <ng-container
        *ngTemplateOutlet="cadTreeNode; context: { $implicit: cadObject }"
      />
    } @empty {
      <p class="p-2 text-sm text-muted-color">No CAD objects are available.</p>
    }
  </div>
</section>

<ng-template #cadTreeNode let-cadObject>
  <div>
    <div
      class="flex min-h-10 items-center gap-1 rounded-md px-3 py-2 text-sm outline-none transition-colors"
      [class]="
        isSelected(cadObject)
          ? 'bg-highlight font-medium text-primary ring-1 ring-inset ring-primary'
          : isHovered(cadObject)
            ? 'bg-surface-switch-200'
            : ''
      "
      tabindex="0"
      [class.cursor-pointer]="selectable"
      [attr.aria-selected]="selectable ? isSelected(cadObject) : null"
      (click)="selectCadObject(cadObject)"
      (mouseenter)="setHoveredCadObject(cadObject.id)"
      (mouseleave)="setHoveredCadObject(null)"
      (focusin)="setHoveredCadObject(cadObject.id)"
      (focusout)="setHoveredCadObject(null)"
    >
      @if (cadObject.children?.length) {
        <p-button
          [icon]="
            isExpanded(cadObject) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
          "
          [text]="true"
          [severity]="isSelected(cadObject) ? 'primary' : 'secondary'"
          size="small"
          (onClick)="toggleExpanded(cadObject); $event.stopPropagation()"
          [attr.aria-expanded]="isExpanded(cadObject)"
          aria-label="Toggle CAD object children"
        />
      } @else {
        <i
          class="pi pi-circle-fill w-8 text-center !text-[0.5rem]"
          [class.text-primary]="isSelected(cadObject)"
          [class.text-muted-color]="!isSelected(cadObject)"
        ></i>
      }

      <span class="flex min-w-0 flex-1 items-center gap-2">
        <span
          class="truncate"
          [class.opacity-40]="!isVisible(cadObject)"
          [title]="cadObject.name"
        >
          {{ cadObject.name }}
        </span>
        @if (isPrimary(cadObject)) {
          <span
            class="shrink-0 rounded-full bg-primary px-3 py-1 text-sm font-medium text-primary-contrast"
          >
            Primary
          </span>
        }
      </span>
      <p-button
        [icon]="isVisible(cadObject) ? 'pi pi-eye' : 'pi pi-eye-slash'"
        [text]="true"
        severity="secondary"
        size="small"
        (onClick)="toggleVisibility(cadObject); $event.stopPropagation()"
        [pTooltip]="isVisible(cadObject) ? 'Hide' : 'Show'"
        tooltipPosition="top"
        [attr.aria-label]="
          isVisible(cadObject) ? 'Hide CAD object' : 'Show CAD object'
        "
      />
    </div>
    @if (isExpanded(cadObject) && cadObject.children?.length) {
      <div class="ml-4">
        @for (child of cadObject.children; track child.id) {
          <ng-container
            *ngTemplateOutlet="cadTreeNode; context: { $implicit: child }"
          />
        }
      </div>
    }
  </div>
</ng-template>
